import flowValveApi from '@/api/config/flowValveApi'
import { queryKeys } from '@/constant/common'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-hot-toast'
import { getApiErrorMessage } from '@/helpers'

// SRC controller needs time to propagate cleared error state to the read API.
// Without this delay an immediate refetch returns the same stale errors that
// existed before the reset call.
const RESET_PROPAGATION_DELAY_MS = 800

const wait = (ms: number) =>
  new Promise<void>((resolve) => setTimeout(resolve, ms))

async function resetFlowValve(interfaceId: number) {
  await flowValveApi.resetError(interfaceId)
}

function useResetFlowValve() {
  const queryClient = useQueryClient()

  return useMutation((interfaceId: number) => resetFlowValve(interfaceId), {
    onSuccess: async () => {
      await wait(RESET_PROPAGATION_DELAY_MS)
      await Promise.all([
        queryClient.refetchQueries([queryKeys.flowValve]),
        queryClient.refetchQueries([queryKeys.flowValveError]),
        queryClient.refetchQueries([queryKeys.hydraulic]),
        queryClient.refetchQueries([queryKeys.flowRule]),
      ])
      toast.success('Reset All FlowValve Success')
    },
    onError: (error: any) => {
      toast.error(getApiErrorMessage(error))
    },
  })
}

export default useResetFlowValve
